import { render, staticRenderFns } from "./AbkMessagesList.vue?vue&type=template&id=03722c54&scoped=true&"
import script from "./AbkMessagesList.vue?vue&type=script&lang=js&"
export * from "./AbkMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./AbkMessagesList.vue?vue&type=style&index=0&id=03722c54&scoped=true&lang=scss&"
import style1 from "./AbkMessagesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03722c54",
  null
  
)

export default component.exports